import Fade from "react-reveal/Fade";

export default function SectionThree() {
  const defaultClass = "flex my-auto justify-center";
  return (
    <div className="md:flex md:mb-0 mb-20 space-y-10">
      <div className={`md:w-5/12 order-last ${defaultClass}`}>
        <Fade right>
          <img
            src={`${window.localhost}/img/imgsec3.jpg`}
            className="md:w-full w-10/12"
            alt="Gambar section 2"
          />
        </Fade>
      </div>

      <div className={`md:w-7/12 ${defaultClass}`}>
        <div className="md:space-y-8 space-y-5">
          <Fade bottom>
            <h1 className="md:text-6xl text-4xl font-black">
              PERAN <span className="text-red-creatifa">LOGO</span> UNTUK BISNIS
              ANDA
            </h1>

            <ul className="list-disc text-xl ml-4 space-y-3">
              <li>
                Membantu bisnis anda untuk terlihat lebih profesional. Ini akan
                meningkatkan kepercayaan konsumen terhadap produk/jasa yang anda
                ditawarkan.
              </li>
              <li>
                Sisi desain grafis dari logo mampu meningkatkan awareness dari
                produk/jasa yang ditawarkan. Ciri khas suatu logo menjadi hal
                penting untuk dilakukan karena untuk membedakan antara
                jasa/produk anda dengan brand lain.
              </li>
              <li>
                Identitas brand yang kuat sangatlah penting karena pada umumnya
                manusia lebih mudah mengingat gambar dari pada tulisan.
              </li>
            </ul>
          </Fade>
        </div>
      </div>
    </div>
  );
}
